angular.module('bmsApp.settings').controller('EmailAccountsIndexCtrl', EmailAccountsIndexCtrl);

EmailAccountsIndexCtrl.$inject = [
	'$scope',
	'$state',
	'$ngBootbox',
	'notify',
	'EmailAccountsDataSvc',
];

function EmailAccountsIndexCtrl(
	$scope,
	$state,
	$ngBootbox,
	notify,
	EmailAccountsDataSvc
) {
	let self = this;
	let handlers = {};
	let table = {};

	angular.extend(self, {
		init: init,
		handlers: handlers,
		table: table,
	});

	function init() {
		self.table.getRecords();
	}

	$scope.table = self.table = {
		page: 1, // show first page
		count: $scope.config.table.params.count, // count per page
		sorting: {
			label: 'asc'     // initial sorting
		},
		filter: {
			// search: ''
		},
		data: [],
		dataCount: 0,
		dataFilteredCount: 0,
		getRecords: () => {
			EmailAccountsDataSvc.index(self.table.filter).then((response) => {
				self.table.data = response.data.email_account_collection;
				self.table.dataCount = response.data.email_account_count;
				self.table.dataFilteredCount = response.data.email_account_filtered_count;
			});
		},
		rowClick: (item) => {
			$state.go('main.settings.email-accounts.edit', {
				id: item.id,
			});
		},
		deleteClick: (item, $event) => {
			$event.stopPropagation();
			$ngBootbox.confirm('Are you sure you want to remove this item? This can not be undone.')
				.then(function () {
					EmailAccountsDataSvc.delete(item)
						.then(function (response) {
							notify({
								message: 'Item deleted successfully'
							});
							self.table.getRecords();
						}, function (error) {
							notify({
								message: 'Error deleting item',
								classes: 'error'
							});
						});
				});
		},
	};

}